import { reatomAsync, withDataAtom } from "@reatom/async";
import { withAbort } from "@reatom/framework";
import { API } from "src/api.ts";
import { withIsLoadingAtom } from "src/common/pipes";

export const listWatermarksRequest = reatomAsync(
  async (ctx) =>
    API.objectStorageApi
      .objectStorageControllerListWatermarks({ signal: ctx.controller.signal })
      .then((response) => response.data),
  "listWatermarksRequest",
).pipe(withDataAtom([]), withAbort(), withIsLoadingAtom());
